/**
 * @Copyright 2014-2017 DataVoke, Inc. All rights reserved.
 */


'use strict';

import { EntityBase } from "./entitybase";
import * as tools from '../utils/tools';

class UserDefinition {
    constructor () {
        /**
         * First name of the user.
         * @type {string}
         */
        this.FirstName = "";

        /**
         * Last name of the user.
         * @type {string}
         */
        this.LastName = "";

        /**
         * Login ID of this user entity.
         * @type {string}
         */
        this.LoginID = "";

        /**
         * Description of this user entity.
         * @type {string}
         */
        this.Description = "";

        /**
         * Store the version of the application on the definition when it is created.
         * @type {string}
         */
        this.ClientVersion = app.version;

        /**
         * Cached signature of the password, if saved by the user.
         * @type {string}
         */
        this.PasswordSignature = "";

        /**
         * Flag to indicate if this user is enabled or not.
         * @type {boolean}
         */
        this.IsEnabled = true;

        /**
         * Array of entity linker for forms that should be loaded when user logs in.
         * @type {Array}
         */
        this.ItemsToLaunchOnLoad = [];

        /**
         * Flag to indicate if the password should be changed (forces user to do this).
         * @type {boolean}
         */
        this.ForcePwdChange = true;

        /**
         * Date of last successful login
         * @type {Date|null}
         */
        this.LastSuccessLogin = null;

        /**
         * Array of the entity linkers for forms that have been favorited by this user.
         * @type {Array}
         */
        this.FavoriteViewIDs = [];

        /**
         * Date the password for this user was last updated.
         * @type {Date|null}
         */
        this.LastPWUpdate = null;
    }
}

export class infoVariable {
    constructor (filterString, infoValue) {
        this.FilterString = filterString;
        this.InfoValue = infoValue;
    }
}

export class User extends EntityBase {
    constructor () {
        super();

        /**
         * The initial ID number of the user (negative temp value when created).
         * @type {number}
         */
        this.UserID = tools.tempID();

        /**
         * User definition object
         * @type {UserDefinition}
         */
        this.Definition = new UserDefinition();
    }
}

export function create () {
    return new User();
}
